import { useEffect, useRef } from "react";
import OurServicesItems from "./OurServicesItems";
import { OurServicesStyled } from "./OurServicesStyled";
import { ourServicesConstant } from "./constants";
import { ServiceType } from "./types";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const OurServices = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);
  const itemsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const header = headerRef.current;
    const items = itemsRef.current;

    if (!section || !header || !items) return;

    const ctx = gsap.context(() => {
      // Header animation
      gsap.fromTo(
        header.querySelectorAll(".sectionLabel, h1, p"),
        { opacity: 0, y: 40 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Service cards staggered animation
      const cards = items.children;
      gsap.fromTo(
        cards,
        { opacity: 0, y: 60, scale: 0.9 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.7,
          stagger: 0.12,
          ease: "power3.out",
          scrollTrigger: {
            trigger: items,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, section);

    return () => ctx.revert();
  }, []);

  return (
    <OurServicesStyled id="services" ref={sectionRef}>
      {/* Marquee background text */}
      <div className="marqueeWrapper">
        <div className="marqueeTrack">
          <span className="marqueeText">Services</span>
          <span className="marqueeText">Excellence</span>
          <span className="marqueeText">Quality</span>
          <span className="marqueeText">Services</span>
          <span className="marqueeText">Excellence</span>
          <span className="marqueeText">Quality</span>
        </div>
      </div>

      <div className="ourServicesContainer">
        <div className="sectionHeader" ref={headerRef}>
          <div className="headerLeft">
            <div className="sectionLabel">
              <span className="line" />
              <span>What We Offer</span>
            </div>
            <h1>
              Our <span className="highlight">Services</span>
            </h1>
          </div>
          <div className="headerRight">
            <p>
              Comprehensive technology solutions tailored to meet your business
              needs with exceptional quality and support.
            </p>
          </div>
        </div>

        <div className="serviceItemsContainer" ref={itemsRef}>
          {ourServicesConstant?.map((items: ServiceType, index: number) => {
            return (
              <OurServicesItems
                services={items}
                key={items.id}
                index={index}
              />
            );
          })}
        </div>
      </div>
    </OurServicesStyled>
  );
};

export default OurServices;
